import { Field, TextInput, TextArea, SectionCard, ListAddBtn, ListRemoveBtn } from "./_shared";

export default function EditMethod({ value, onChange }) {
  const set = (k, v) => onChange({ ...value, [k]: v });
  const setPhase = (i, key, v) => {
    const phases = [...(value.phases || [])];
    phases[i] = { ...phases[i], [key]: v };
    set("phases", phases);
  };
  const addPhase = () => {
    const next = String((value.phases || []).length + 1).padStart(2, "0");
    set("phases", [...(value.phases || []), { number: next, title: "Nova Fase", description: "", objective: "" }]);
  };
  const removePhase = (i) => set("phases", (value.phases || []).filter((_, idx) => idx !== i));

  return (
    <SectionCard title="Método (Fases)">
      <div className="space-y-5">
        <Field label="Overline"><TextInput value={value.overline} onChange={(v) => set("overline", v)} testId="method-overline-input" /></Field>
        <Field label="Título"><TextInput value={value.title} onChange={(v) => set("title", v)} testId="method-title-input" /></Field>
        <Field label="Subtítulo"><TextArea value={value.subtitle} onChange={(v) => set("subtitle", v)} rows={2} testId="method-subtitle-input" /></Field>

        <div>
          <div className="flex items-center justify-between mb-3">
            <span className="text-xs tracking-[0.2em] uppercase text-onyx/60">Fases</span>
            <ListAddBtn onClick={addPhase} label="Adicionar fase" testId="method-add-phase" />
          </div>
          <div className="space-y-5">
            {(value.phases || []).map((p, i) => (
              <div key={i} data-testid={`method-phase-row-${i}`} className="border border-border p-5 relative">
                <div className="absolute top-3 right-3">
                  <ListRemoveBtn onClick={() => removePhase(i)} testId={`method-phase-remove-${i}`} />
                </div>
                <div className="grid sm:grid-cols-4 gap-4">
                  <Field label="Número"><TextInput value={p.number} onChange={(v) => setPhase(i, "number", v)} testId={`method-phase-number-${i}`} /></Field>
                  <div className="sm:col-span-3">
                    <Field label="Título"><TextInput value={p.title} onChange={(v) => setPhase(i, "title", v)} testId={`method-phase-title-${i}`} /></Field>
                  </div>
                </div>
                <div className="mt-3"><Field label="Descrição"><TextArea value={p.description} onChange={(v) => setPhase(i, "description", v)} rows={2} testId={`method-phase-description-${i}`} /></Field></div>
                <div className="mt-3"><Field label="Objetivo"><TextInput value={p.objective} onChange={(v) => setPhase(i, "objective", v)} testId={`method-phase-objective-${i}`} /></Field></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </SectionCard>
  );
}
